import { handleActions } from 'redux-actions';
import { CompaniesState } from './interfaces';
import Types from './types';

const initialState: CompaniesState = {
  isLoading: false,
  companyDetails: null,
  companyList: {
    count: 0,
    next: '',
    previous: '',
    results: [],
  },
  companiesList: {
    count: 0,
    next: '',
    previous: '',
    results: [],
  },
  usersCompanyList: {
    count: 0,
    next: '',
    previous: '',
    results: [],
  },
};

export default handleActions(
  {
    [Types.GET_COMPANY_REQUEST]: (state: CompaniesState) => ({
      ...state,
      isLoading: true,
      companyDetails: null,
    }),
    [Types.GET_COMPANY_FULFILLED]: (state: CompaniesState, { payload }) => ({
      ...state,
      isLoading: false,
      companyDetails: payload,
    }),
    [Types.GET_COMPANY_REJECTED]: (state: CompaniesState) => ({
      ...state,
      isLoading: false,
      companyDetails: null,
    }),

    [Types.GET_ALL_USER_COMPANY_REQUEST]: (state: CompaniesState) => ({
      ...state,
      isLoading: true,
      usersCompanyList: initialState.usersCompanyList,
    }),
    [Types.GET_ALL_USER_COMPANY_FULFILLED]: (
      state: CompaniesState,
      { payload }
    ) => ({
      ...state,
      isLoading: false,
      usersCompanyList: payload,
    }),
    [Types.GET_ALL_USER_COMPANY_REJECTED]: (state: CompaniesState) => ({
      ...state,
      isLoading: false,
      companyDetails: null,
    }),

    [Types.GET_ALL_COMPANIES_REQUEST]: (state: CompaniesState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.GET_ALL_COMPANIES_FULFILLED]: (
      state: CompaniesState,
      { payload }
    ) => ({
      ...state,
      companyList: payload,
      isLoading: false,
    }),
    [Types.GET_ALL_COMPANIES_REJECTED]: (state: CompaniesState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.GET_ALL_COMPANIES_OPERATOR_REQUEST]: (state: CompaniesState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.GET_ALL_COMPANIES_OPERATOR_FULFILLED]: (
      state: CompaniesState,
      { payload }
    ) => ({
      ...state,
      companiesList: payload,
      isLoading: false,
    }),
    [Types.GET_ALL_COMPANIES_OPERATOR_REJECTED]: (state: CompaniesState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.EDIT_COMPANY_NAMES_REQUEST]: (state: CompaniesState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.EDIT_COMPANY_NAMES_FULFILLED]: (state: CompaniesState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.EDIT_COMPANY_NAMES_REJECTED]: (state: CompaniesState) => ({
      ...state,
      isLoading: false,
    }),
  },
  initialState
);
